import {
  FETCH_CART_REQUEST,
  FETCH_CART_SUCCESS,
  FETCH_CART_FAILURE,
  ADD_TO_CART_REQUEST,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_FAILURE,
  REMOVE_FROM_CART_REQUEST,
  REMOVE_FROM_CART_SUCCESS,
  REMOVE_FROM_CART_FAILURE,
  CLEAR_CART_REQUEST,
  CLEAR_CART_SUCCESS,
  CLEAR_CART_FAILURE,
  TOGGLE_CART,
  CLOSE_CART,
} from '../actions';

const defaultCartState = {
  total: 0,
  quantity: false,
  products: [],
  loading: false,
  error: false,
  active: false
};

const reducer = (state = defaultCartState, action) => {
  switch(action.type){
    case TOGGLE_CART:
      return {
        ...state,
        active: !state.active
      };
    case CLOSE_CART:
      return {
        ...state,
        active: false
      };
    case FETCH_CART_REQUEST:
    case ADD_TO_CART_REQUEST:
    case REMOVE_FROM_CART_REQUEST:
    case CLEAR_CART_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CART_SUCCESS:
    case ADD_TO_CART_SUCCESS:
    case REMOVE_FROM_CART_SUCCESS:
      return {
        ...state,
        total: action.cart.total,
        quantity: action.cart.quantity,
        products: action.cart.products,
        loading: false,
      };
    case FETCH_CART_FAILURE:
    case ADD_TO_CART_FAILURE:
    case REMOVE_FROM_CART_FAILURE:
    case CLEAR_CART_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };
    case CLEAR_CART_SUCCESS:
      return {
        ...state,
        products: defaultCartState.products,
        loading: false
      }
    default:
      return state;
  }
}

export default reducer;
